export const CATEGORY_NAME_REQUIRED_MESSAGE = 'Category Name is required.'

export const validateAssetCategoryName = (name: string): string | undefined =>
  name.trim() ? undefined : CATEGORY_NAME_REQUIRED_MESSAGE

export const isAssetCategoryNameValidationError = (response: unknown): boolean => {
  if (!response || typeof response !== 'object') return false

  const details = response as Record<string, any>
  const serialized = JSON.stringify(response)
  const identifiesName = /(?:\/name\b|["']?name["']?\s*:)/i.test(serialized)
  const isValidation =
    details.type === 'validation' ||
    details.statusCode === 422 ||
    /validation|expected string length|must be at least|minimum length/i.test(String(details.message || ''))

  return identifiesName && isValidation
}
